import axios from "axios";
import { store } from "../../redux/store";
import allEnvs from "../env.config";
import { clearUser, setMainTokens } from "../../redux/auth/auth.slice";

/** 
    @description this function create to we can have a shared axios with interceptors and other things
    @param {string} baseURL - the base url of the axios instance
    @param {string} timeout - the timeout of the axios instance
    @return {object} - the axios instance
 */
function createAxios({ baseURL, timeout }) {
	let retry = false;
	const axiosConfig = {
		baseURL,
		timeout,
	};

	const axiosInstance = axios.create(axiosConfig);

	// check if pathname is /login page don't redirect to login page
	function isMoveToLogin() {
		const { pathname } = window.location;
		// return pathname !== "/login";
	}

	/**
	 * @description this function add user role
	 * @param {Object} config - axios config object
	 * @return {Object} - axios config object
	 */
	function addCityPrefixToUrl(config) {
		// we add selected city prefix to the baseUrl
		const cityPrefix = store.getState()?.tempData?.tempSelectedCity?.subUrl ?? allEnvs.defaultCityPrefix;

		const resolvedUrl = allEnvs.baseUrl.replace("{CITY_PREFIX}", cityPrefix);

		return resolvedUrl;
	}

	function getToken() {
		const token = store.getState()?.currentUser?.token ?? localStorage.getItem("token");

		return token;
	}

	function getRefreshToken() {
		const refreshToken = store.getState()?.currentUser?.refreshToken;

		return refreshToken;
	}

	function getAppVersion() {
		const version = allEnvs.version;
		return `pwa-${version}`;
	}

	async function catch401Error(error) {
		const originalRequest = error.config;

		const kickAssUser = () => {
			localStorage.clear();
			store.dispatch(clearUser());
			window.location.href = "/introduction";
		};

		if (error.response && error.response.status === 401) {
			if (!retry) {
				retry = true;
				const refreshToken = getRefreshToken() ?? getToken();

				try {
					const newToken = (
						await axiosInstance.post(
							"/auth/local/refreshToken",
							{},
							{
								headers: {
									Authorization: `Bearer ${refreshToken}`,
								},
							}
						)
					).data.token;

					originalRequest.headers.Authorization = newToken;

					store.dispatch(
						setMainTokens({
							refreshToken: refreshToken,
							token: newToken,
						})
					);

					return axiosInstance(originalRequest);
				} catch (e) {
					kickAssUser();
				}
			} else {
				kickAssUser();
			}
		}
		return Promise.reject(error);
	}

	axiosInstance.interceptors.request.use(
		(config) => {
			const withCityPrefixUrl = addCityPrefixToUrl();

			const authHeader = getToken() ?? getRefreshToken();

			return {
				...config,
				baseURL: withCityPrefixUrl,
				headers: {
					Authorization: config.url.includes("/auth/local/refreshToken")
						? `Bearer ${getRefreshToken()} `
						: `Bearer ${authHeader}`,
					version: getAppVersion(),
				},
			};
		},
		(error) => Promise.reject(error)
	);

	axiosInstance.interceptors.response.use((response) => response, catch401Error);

	return axiosInstance;
}

export default createAxios;
